export default __webpack_public_path__ + "static/media/phone.6fe26715.jpg";